import { render, staticRenderFns } from "./UtilityListLink.vue?vue&type=template&id=683a8020&scoped=true&"
import script from "./UtilityListLink.vue?vue&type=script&lang=js&"
export * from "./UtilityListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a8020",
  null
  
)

export default component.exports